module.exports = __webpack_public_path__ + "img/top10FilterOff.371f1007.svg";